// extracted by css-extract-rspack-plugin
export default {"unFavoritedIcon":"favorite-menu-option-module__unFavoritedIcon___c8jsd"};